import React from 'react'

// Logo SVG Suiveo BTP : bâtiment stylisé + barre de progression
// size : 'sm' (sidebar, 32px), 'md' (login, 40px), 'lg' (landing, 56px)
export default function Logo({ size = 'md', withText = false, textColor = '#1a202c' }) {
  const dim = size === 'sm' ? 32 : size === 'lg' ? 56 : 40
  const textSize = size === 'sm' ? 15 : size === 'lg' ? 24 : 18

  const icon = (
    <svg width={dim} height={dim} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ flexShrink: 0 }}>
      {/* Fond arrondi */}
      <rect width="40" height="40" rx="10" fill="#1D9E75"/>
      {/* Bâtiment principal */}
      <rect x="8" y="18" width="16" height="14" rx="1" fill="white" opacity="0.95"/>
      {/* Toit / triangle */}
      <path d="M6 19 L16 10 L26 19" stroke="white" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
      {/* Porte */}
      <rect x="13" y="25" width="6" height="7" rx="1" fill="#1D9E75"/>
      {/* Fenêtre */}
      <rect x="10" y="21" width="4" height="3" rx="0.5" fill="#1D9E75" opacity="0.7"/>
      {/* Barre de progression (droite) */}
      <rect x="27" y="20" width="5" height="12" rx="1" fill="white" opacity="0.25"/>
      <rect x="27" y="26" width="5" height="6" rx="1" fill="white" opacity="0.9"/>
      {/* Coche / check */}
      <circle cx="30" cy="14" r="5" fill="white"/>
      <path d="M27.5 14 L29.2 15.8 L32.5 12.5" stroke="#1D9E75" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  )

  if (!withText) return icon

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: size === 'sm' ? 8 : 10 }}>
      {icon}
      <span style={{
        fontSize: textSize, fontWeight: 800, color: textColor,
        letterSpacing: '-0.3px', lineHeight: 1,
      }}>
        Suiveo <span style={{ color: '#1D9E75' }}>BTP</span>
      </span>
    </div>
  )
}
